/* ====================================================================
   VERDICT GOODS — vg-case.js
   The case builder over the REAL Shopify cart (Cart Ajax API).
   Replaces the source's sessionStorage case (case.js): slots = cart line
   items; every mutation re-renders the case bar (and cart page) via the
   Section Rendering API so server truth always wins.
   Progressive enhancement: without JS every form posts natively.
   ==================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var VG = window.VG || { caseSize: 4, strings: {} };
  var busy = false;

  function bar() { return document.getElementById('case-bar'); }
  function live() { return document.getElementById('case-live'); }
  function count() {
    var b = bar();
    if (b) return parseInt(b.getAttribute('data-count'), 10) || 0;
    return VG.cartCount || 0;
  }
  function announce(msg) {
    var l = live();
    if (l) l.textContent = msg;
  }
  function fmt(str, map) {
    return String(str || '').replace(/\[(\w+)\]/g, function (_, k) { return map[k] != null ? map[k] : ''; });
  }

  function sectionWrapper(el) { return el.closest('.shopify-section'); }
  function sectionsToRender() {
    var ids = [];
    var b = bar();
    if (b) {
      var w = sectionWrapper(b);
      if (w) ids.push(w.id.replace(/^shopify-section-/, ''));
    }
    var review = document.querySelector('[data-vg-case-review]');
    if (review && review.getAttribute('data-section-id')) ids.push(review.getAttribute('data-section-id'));
    var bubble = document.querySelector('[data-vg-cart-count]');
    if (bubble) { /* count updated from refreshed bar; no extra section needed */ }
    return ids;
  }

  function swapSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var target = document.getElementById('shopify-section-' + id);
      if (!target || !sections[id]) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.querySelector('.shopify-section') || doc.body;
      target.innerHTML = fresh.innerHTML;
      if (window.Verdict && window.Verdict.initScope) window.Verdict.initScope(target);
      if (window.VerdictSite && window.VerdictSite.initScope) window.VerdictSite.initScope(target);
    });
    var b = bar();
    var bubble = document.querySelector('[data-vg-cart-count]');
    if (bubble && b) {
      var c = parseInt(b.getAttribute('data-count'), 10) || 0;
      bubble.textContent = c;
      bubble.hidden = c === 0;
    }
    document.dispatchEvent(new CustomEvent('vg:cart:updated'));
  }

  function request(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(payload)
    });
  }

  /* ---------------- animations (ported from source case.js) ---------------- */
  function spawnCrumbs(anchorEl) {
    if (reduce) return;
    var rect = anchorEl.getBoundingClientRect();
    for (var i = 0; i < 3; i++) {
      var c = document.createElement('span');
      c.className = 'case-crumb';
      var size = 4 + Math.random() * 4;
      c.style.width = c.style.height = size + 'px';
      c.style.left = (rect.left + rect.width / 2) + 'px';
      c.style.top = (rect.top + rect.height / 2) + 'px';
      document.body.appendChild(c);
      var angle = (-60 + Math.random() * 120) * Math.PI / 180;
      var dist = 26 + Math.random() * 22;
      var cx = Math.sin(angle) * dist, cy = -Math.abs(Math.cos(angle) * dist) - 8;
      var anim = c.animate([
        { transform: 'translate(0,0)', opacity: 1 },
        { transform: 'translate(' + cx + 'px,' + cy + 'px)', opacity: 1, offset: .5 },
        { transform: 'translate(' + (cx * 1.3) + 'px,' + (cy + 40) + 'px)', opacity: 0 }
      ], { duration: 560, easing: 'cubic-bezier(.2,.7,.3,1)' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(c);
    }
  }

  function flyAnimate(fromRect, imgSrc) {
    if (reduce || !fromRect) return;
    var b = bar();
    if (!b) return;
    var slots = b.querySelectorAll('.case-slot.is-filled');
    var slotEl = slots[slots.length - 1];
    if (!slotEl) return;
    var toRect = slotEl.getBoundingClientRect();
    var ghost = document.createElement('img');
    ghost.src = imgSrc || '';
    ghost.className = 'case-fly-ghost';
    ghost.alt = '';
    ghost.style.left = fromRect.left + fromRect.width / 2 - 22 + 'px';
    ghost.style.top = fromRect.top + fromRect.height / 2 - 22 + 'px';
    document.body.appendChild(ghost);
    var dx = (toRect.left + toRect.width / 2) - (fromRect.left + fromRect.width / 2);
    var dy = (toRect.top + toRect.height / 2) - (fromRect.top + fromRect.height / 2);
    var midDy = dy - 120;
    var anim = ghost.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1, offset: 0 },
      { transform: 'translate(' + (dx * 0.5) + 'px,' + midDy + 'px) scale(.9) rotate(-12deg)', opacity: 1, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.42) rotate(10deg) scaleY(.85)', opacity: .95, offset: 1 }
    ], { duration: 620, easing: 'cubic-bezier(.3,.6,.25,1)' });
    anim.onfinish = function () {
      ghost.remove();
      slotEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }],
        { duration: 340, easing: 'cubic-bezier(.3,1.4,.4,1)' });
      spawnCrumbs(slotEl);
      b.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(-6px)' }, { transform: 'translateY(0)' }],
        { duration: 380, easing: 'cubic-bezier(.3,1.2,.4,1)' });
    };
  }

  function stampSlam() {
    if (reduce) return;
    var b = bar();
    if (!b) return;
    b.classList.add('just-closed');
    setTimeout(function () { b.classList.remove('just-closed'); }, 900);
  }

  /* ---------------- error surfaces ---------------- */
  function showFormError(form, message) {
    var slot = form && form.closest('.el-actions, .pc-buy, [data-vg-case-review]');
    var box = slot && slot.parentElement ? slot.parentElement.querySelector('[data-vg-form-error]') : null;
    if (!box) box = document.querySelector('[data-vg-form-error]');
    if (box) {
      box.textContent = message;
      box.hidden = false;
      clearTimeout(box._t);
      box._t = setTimeout(function () { box.hidden = true; }, 6000);
    }
    announce(message);
  }

  /* ---------------- add to case ---------------- */
  function addToCase(variantId, quantity, sourceEl, form) {
    if (busy) return;
    var current = count();
    var size = VG.caseSize || 4;
    if (!VG.allowMultipleCases && current + quantity > size) {
      quantity = size - current;
      if (quantity <= 0) {
        announce(VG.strings.caseFull || 'Case is full.');
        stampSlam();
        return;
      }
    }
    busy = true;
    var fromRect = sourceEl ? sourceEl.getBoundingClientRect() : null;
    var imgSrc = '';
    if (sourceEl) {
      var card = sourceEl.closest('.product-card, .evidence-label, .pdp-grid, .sec-pdp');
      var img = card && card.querySelector('img');
      if (img) imgSrc = img.currentSrc || img.src;
    }
    request((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
      id: Number(variantId),
      quantity: quantity,
      sections: sectionsToRender()
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    }).then(function (r) {
      busy = false;
      if (!r.ok) {
        showFormError(form, r.json.description || r.json.message || (VG.strings.cartError || 'Something went wrong.'));
        return;
      }
      swapSections(r.json.sections);
      var c = count();
      var letter = sourceEl ? (sourceEl.getAttribute('data-add-exhibit') || sourceEl.getAttribute('data-fill-exhibit') || '') : '';
      announce(fmt(VG.strings.filed, { letter: letter, count: c, size: size }));
      flyAnimate(fromRect, imgSrc);
      if (c >= size) setTimeout(stampSlam, reduce ? 0 : 500);
    }).catch(function () {
      busy = false;
      showFormError(form, VG.strings.cartError || 'Something went wrong. Please try again.');
    });
  }

  /* ---------------- remove one unit from a line ---------------- */
  function changeLine(lineKey, newQty, letter) {
    if (busy) return;
    busy = true;
    request((window.routes && window.routes.cart_change_url || '/cart/change') + '.js', {
      id: lineKey,
      quantity: newQty,
      sections: sectionsToRender()
    }).then(function (res) {
      return res.json().then(function (json) { return { ok: res.ok, json: json }; });
    }).then(function (r) {
      busy = false;
      if (!r.ok) {
        showFormError(null, r.json.description || (VG.strings.cartError || 'Something went wrong.'));
        return;
      }
      swapSections(r.json.sections);
      announce(fmt(VG.strings.removed, { letter: letter || '', count: count(), size: VG.caseSize || 4 }));
    }).catch(function () {
      busy = false;
      showFormError(null, VG.strings.cartError || 'Something went wrong. Please try again.');
    });
  }

  /* ---------------- delegated events (work for late-rendered nodes) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-vg-add-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var id = form.querySelector('input[name="id"]');
    var qty = form.querySelector('input[name="quantity"]');
    var btn = form.querySelector('[data-add-exhibit]') || form.querySelector('button[type="submit"]');
    if (!id) return;
    addToCase(id.value, qty ? parseInt(qty.value, 10) || 1 : 1, btn, form);
  });

  document.addEventListener('click', function (e) {
    /* fill every remaining slot with this exhibit */
    var fill = e.target.closest('[data-fill-exhibit]');
    if (fill) {
      var remaining = (VG.caseSize || 4) - count();
      if (remaining <= 0) {
        announce(VG.strings.caseFull || 'Case is full.');
        stampSlam();
        return;
      }
      addToCase(fill.getAttribute('data-variant-id'), remaining, fill, fill.closest('form') || fill.parentElement.querySelector('form'));
      return;
    }
    /* case-bar slot click removes one unit of that line */
    var slot = e.target.closest('#case-bar .case-slot.is-filled');
    if (slot) {
      var qty = parseInt(slot.getAttribute('data-line-qty'), 10) || 1;
      var letterEl = slot.querySelector('.case-slot-letter');
      changeLine(slot.getAttribute('data-line-key'), qty - 1, letterEl ? letterEl.textContent : '');
      return;
    }
    /* cart page remove button (progressive enhancement over the anchor fallback) */
    var rm = e.target.closest('[data-vg-remove-line]');
    if (rm && window.fetch) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-line-key'), parseInt(rm.getAttribute('data-target-qty'), 10) || 0, rm.getAttribute('data-letter') || '');
    }
  });

  /* expandable criterion rows on the PDP evidence label */
  document.addEventListener('click', function (e) {
    var row = e.target.closest('[data-vg-expand]');
    if (!row) return;
    row.classList.toggle('is-open');
    row.setAttribute('aria-expanded', row.classList.contains('is-open') ? 'true' : 'false');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var row = e.target.closest('[data-vg-expand]');
    if (!row) return;
    e.preventDefault();
    row.classList.toggle('is-open');
    row.setAttribute('aria-expanded', row.classList.contains('is-open') ? 'true' : 'false');
  });

  /* PDP thumbnail gallery (delegated; survives section reloads) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-thumb');
    if (!btn) return;
    var gallery = btn.closest('.pdp-gallery');
    var main = gallery && gallery.querySelector('.pdp-main-photo img');
    if (!main) return;
    var src = btn.getAttribute('data-src');
    var srcset = btn.getAttribute('data-srcset');
    if (src) main.src = src;
    if (srcset) main.srcset = srcset;
    var alt = btn.getAttribute('data-alt');
    if (alt !== null) main.alt = alt;
    gallery.querySelectorAll('.pdp-thumb').forEach(function (b) {
      b.classList.toggle('is-active', b === btn);
      b.setAttribute('aria-current', b === btn ? 'true' : 'false');
    });
  });
})();
